import { LINK_COMPLIANCE_WHERE_CAN_I_FIND_BUSINESS_INFO } from 'shared/constants/links'
import { LinkButton } from './LinkButton'

export const WhereCanIFindBusinessInfoButton = () => (
  <LinkButton text={'Where can I find it?'} link={LINK_COMPLIANCE_WHERE_CAN_I_FIND_BUSINESS_INFO} />
)
